import { Component } from '@angular/core';

@Component({
    selector: 'app-course-card',
    templateUrl: './course-card.component.html',
    styleUrls: ['./course-card.component.scss'],
    standalone: false
})
export class CourseCardComponent {

}
